/* eslint-disable react/jsx-no-script-url, no-script-url */

import { Flex, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { useNavContext } from '@lemonade-hq/nuiza';
import type React from 'react';
import { useCallback } from 'react';
import { scroller } from 'react-scroll';
import styled from 'styled-components';
import { globalShare } from '../GivebackShared/GivebackShareButton';
import Giveback2021SpecialButton from './Giveback2021SpecialButton';
import { SHARING_CONTENT, SHARING_EVENT, SHARING_URL, TITLE } from './giveback2021Consts';
import useValueAtRest from './useValueAtRest';

const RESTART_SCROLL_DURATION = 4500;
const RESTART_BUTTON_DELAY = 300;
const RESTART_BUTTON_SHOW_POINT = 0.99;

const Container = styled(Flex)`
  text-align: center;
  margin: 0 auto;
  padding: 0 10px;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2;

  ${MEDIA_QUERIES.mobile`
        letter-spacing: -2px;
        ${font('main', { fontSize: '34px', lineHeight: 1, fontWeight: 900 })};
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        max-width: 1044px;
        letter-spacing: -4px;
        ${font('main', { fontSize: '72px', lineHeight: 1, fontWeight: 900 })};
    `};
`;

const RestartButton = styled(Giveback2021SpecialButton)`
  width: 180px;
  position: absolute;
  bottom: 20px;
`;

const Giveback2021Footer: React.FC<{ t: number; presentationMode: boolean }> = ({ t, presentationMode }) => {
  const { nav } = useNavContext();

  const bottomButtonShown = useValueAtRest({
    changingValue: t,
    duration: RESTART_BUTTON_DELAY,
    condition: t > RESTART_BUTTON_SHOW_POINT && !presentationMode,
  });

  const handleRestart = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    scroller.scrollTo('header', {
      duration: RESTART_SCROLL_DURATION,
      smooth: true,
    });
  }, []);

  return (
    <Container>
      <div>
        As our community grows, so does your impact. The Lemonade Giveback supports over 100 nonprofit organizations
        across the U.S. and Europe. Help build our program&nbsp;
        <a href={nav.giveback} data-event="giveback2021.learn_more.clicked">
          here
        </a>
        &nbsp;and&nbsp;
        {/* biome-ignore lint/a11y/useValidAnchor: <explanation> */}
        <a
          href="javascript:;"
          data-event={SHARING_EVENT}
          onClick={() => globalShare(true, TITLE, SHARING_CONTENT, SHARING_URL)}
        >
          share
        </a>
        .
      </div>
      <RestartButton shown={bottomButtonShown} onClick={handleRestart}>
        Wanna go again?
      </RestartButton>
    </Container>
  );
};

export default Giveback2021Footer;
